<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
    },
    methods:{
        filter: function(){
            
            let state = this;
            state.items = [];
            state.filters.company = state.$session.get('user').companyUser.company._id;
            $('#spinner').modal('toggle');
            Request.do(state, 'POST', Request.getDefaultHeader(state), state.filters, `${Endpoints.alerts.filter}`,
            (response)=>{//SUCCESS CALLBACK
                state.items = response.results;
                $('#spinner').modal('toggle');
            },
            (error)=>{//ERROR CALLBACK
                console.log(error);
            });
        },
        selectItem: function(item){
            this.$emit('load-item', item);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
